import { resolveTableColumnAliases } from './tableColumnAliases.mjs'

export function serializeTableColumns(keys) {
    return keys.join(',')
}

export function tableColumnOrder(available, keys, order) {
    const resolved = resolveTableColumnAliases(order ?? keys ?? [], null, available).columns
    const known = new Map(available.map((column) => [column.key, column]))
    return [...new Set([...resolved, ...available.map((column) => column.key)])]
        .filter((key) => known.has(key) && known.get(key).display !== 'mandatory')
}

export function orderedTableColumns(available, keys, order) {
    const resolvedKeys = resolveTableColumnAliases(keys ?? available.filter((column) => column.display === 'optional_default').map((column) => column.key), null, available).columns
    const mandatory = available.filter((column) => column.display === 'mandatory')
    const selected = new Set(resolvedKeys)
    const byKey = new Map(available.map((column) => [column.key, column]))
    const optional = tableColumnOrder(available, keys, order).filter((key) => selected.has(key)).map((key) => byKey.get(key))
    return [...mandatory, ...optional]
}
